import { LoadingStates } from '@pb/utils'

export default {
  membershipLoadingState: LoadingStates.NotLoaded,
  membershipDetail: {},
}
